import {
  BadgeCheck,
  Bell,
  CircleUserRound,
  FileUser,
  LayoutDashboard,
  Medal,
  ShieldCheck,
  Sparkles,
} from "lucide-react";

export const applicantNavigationItems = [
  {
    href: "/dashboard/applicant",
    label: "Dashboard",
    icon: LayoutDashboard,
    match: (location) => location.pathname === "/dashboard/applicant",
  },
  {
    href: "/dashboard/applicant/edit-profile",
    label: "Profil",
    icon: CircleUserRound,
    match: (location) => location.pathname === "/dashboard/applicant/edit-profile",
  },
  {
    href: "/dashboard/applicant/bewerbung",
    label: "Bewerbung",
    icon: FileUser,
    match: (location) => location.pathname === "/dashboard/applicant/bewerbung" || location.pathname === "/dashboard/applicant/cv2",
  },
  {
    href: "/dashboard/applicant/sprachtest-b1",
    label: "Sprachtest B1",
    icon: BadgeCheck,
    match: (location) => location.pathname === "/dashboard/applicant/sprachtest-b1",
  },
  {
    href: "/dashboard/applicant/matches",
    label: "Matches",
    icon: Sparkles,
    match: (location) => location.pathname === "/dashboard/applicant/matches",
  },
  {
    href: "/dashboard/applicant/nachrichten",
    label: "Nachrichten",
    icon: Bell,
    match: (location) => location.pathname === "/dashboard/applicant/nachrichten",
  },
  {
    href: "/dashboard/applicant/erfolge",
    label: "Erfolge",
    icon: Medal,
    match: (location) => location.pathname === "/dashboard/applicant/erfolge",
  },
  {
    href: "/dashboard/account",
    label: "Konto",
    icon: ShieldCheck,
    match: (location) => location.pathname === "/dashboard/account",
  },
];
